/* Add-to-cart toast: the cart-notification element Dawn's product-form.js talks to (snippets/ez-cart-toast.liquid).
   On add: refresh the header cart count, name what was added, show the card for 2 seconds (owner: "go away automatically in 1-2 seconds") (held while hovered
   or focused), announce it once. No focus change, no overlay, no scroll lock. */
(function () {
  'use strict';
  if (customElements.get('cart-notification')) return;
  class EzCartToast extends HTMLElement {
    connectedCallback() {
      this.card = this.querySelector('[data-ez-toast-card]');
      this.item = this.querySelector('[data-ez-toast-item]');
      this.live = this.querySelector('[data-ez-toast-live]');
      this.querySelector('[data-ez-toast-close]').addEventListener('click', () => this.hide());
      this.card.addEventListener('mouseenter', () => clearTimeout(this.timer));
      this.card.addEventListener('mouseleave', () => this.arm());
      this.card.addEventListener('focusin', () => clearTimeout(this.timer));
      this.card.addEventListener('focusout', () => this.arm());
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.classList.contains('is-open')) this.hide(); });
    }
    getSectionsToRender() { return [{ id: 'cart-icon-bubble' }]; }
    setActiveElement(el) { this.activeElement = el; }
    renderContents(state) {
      var html = state.sections && state.sections['cart-icon-bubble'];
      var bubble = document.getElementById('cart-icon-bubble');
      if (html && bubble) {
        var sec = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        if (sec) bubble.innerHTML = sec.innerHTML;
      }
      var opts = state.variant_title && state.variant_title !== 'Default Title' ? ', ' + state.variant_title.replace(/ \/ /g, ', ') : '';
      this.item.textContent = (state.product_title || '') + opts;
      var live = this.live, msg = 'Added to your cart: ' + this.item.textContent;
      live.textContent = '';
      setTimeout(function () { live.textContent = msg; }, 60);
      this.classList.add('is-open');
      this.arm();
    }
    arm() {
      clearTimeout(this.timer);
      if (this.card.matches(':hover') || this.card.contains(document.activeElement)) return;
      this.timer = setTimeout(() => this.hide(), 2000);
    }
    hide() {
      clearTimeout(this.timer);
      if (this.card.contains(document.activeElement) && this.activeElement && this.activeElement.focus) this.activeElement.focus();
      this.classList.remove('is-open');
    }
  }
  customElements.define('cart-notification', EzCartToast);
})();
